import { Dropdown } from 'primereact/dropdown'
import React, { useEffect, useState } from 'react'
import api from '../../services/api'

const CategoriaSelector = ({ onCategoriaChange }) => {
    const [categorias, setCategorias] = useState([])
    const [selectedCategoria, setSelectedCategoria] = useState(null)

    useEffect(() => {
        const buscarCategorias = async () => {
            try {
                const response = await api.get('/api/categorias')
                setCategorias(response.data.categorias)
            } catch (error) {
                console.error('Erro ao buscar categorias:', error)
            }
        }

        buscarCategorias()
    }, [])

    const handleCategoriaChange = (e) => {
        setSelectedCategoria(e.value)
        onCategoriaChange(e.value)
    }

    const categoriaTemplate = (option) => {
        if (!option) return <span>Selecione uma categoria</span>

        return (
            <div className="flex align-items-center">
                {option.icon && (
                    <i className={`${option.icon} mr-2`} style={{ color: option.cor || '#6c757d' }}></i>
                )}
                <span>{option.descricao}</span>
            </div>
        )
    }

    const selectedCategoriaTemplate = (option) => {
        if (!option) return <span>Selecione uma categoria</span>

        return (
            <div className="flex align-items-center">
                {option.icon && (
                    <i className={`${option.icon} mr-2`} style={{ color: option.cor || '#6c757d' }}></i>
                )}
                <span>{option.descricao}</span>
            </div>
        )
    }

    return (
        <div className="flex flex-column gap-2">
            <label>Categoria</label>
            <Dropdown
                value={selectedCategoria}
                options={categorias}
                onChange={handleCategoriaChange}
                optionLabel="descricao"
                optionValue="id"
                placeholder="Selecione uma categoria"
                showClear
                className="w-full"
                itemTemplate={categoriaTemplate}
                valueTemplate={selectedCategoriaTemplate}
                filter
                filterBy="descricao"
            />
        </div>
    )
}

export default CategoriaSelector 